import WaveBackground from "../../background/wave-background";
import Logo from "../../logo";
import "./styles.css";

function HeaderTitle() {
  return (
    <div className="header-title-container">
      <WaveBackground />
      <div className="header-title-logo-container">
        <Logo big={true}></Logo>
      </div>
    </div>
  );
}

export default HeaderTitle;
